// Dynamic header cart total updater for Shopify Enterprise theme
(function () {
  const cartTotalSelector = '.header__icon--cart-total';
  const cartTextSelector = '.header__icon--cart-text';
  const cartIconSelector = '.header__icon--cart-text-and-total-amount';

  // Helper: Format price using Shopify or theme fallback
  function formatCartTotal(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      // Use money_with_currency format for cart total
      return Shopify.formatMoney(cents, window.theme?.settings?.moneyWithCurrencyFormat || window.theme?.moneyWithCurrencyFormat || window.theme?.moneyFormat || '{{ amount }}');
    }
    // Fallback: mimic recommendations-add-to-cart.js logic
    const moneyFormat = window.theme?.moneyWithCurrencyFormat || window.theme?.moneyFormat || '{{ amount }}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0,00';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }
    let value = '';
    const match = moneyFormat.match(placeholderRegex);
    if (match) {
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
      }
    }
    return moneyFormat.replace(placeholderRegex, value);
  }

  // Helper: Get currency code (for empty cart display)
  function getCurrencyCode() {
    return (window.theme?.currency?.code || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD');
  }

  // Helper: Update the header cart total
  function updateHeaderCartTotal(cart) {
    const totalEl = document.querySelector(cartTotalSelector);
    if (!totalEl) return;
    // Read format and label from data attributes
    const moneyFormat = totalEl.getAttribute('data-money-format') || window.theme?.moneyFormat || '{{ amount }}';
    const moneyWithCurrencyFormat = totalEl.getAttribute('data-money-with-currency-format') || window.theme?.moneyWithCurrencyFormat || '{{ amount_with_comma_separator }} {{ currency }}';
    const cartTotalLabel = totalEl.getAttribute('data-cart-total-label') || window.theme?.strings?.cart_total || 'Total:';
    const currencySymbol = totalEl.getAttribute('data-cart-currency-symbol') || getCurrencyCode();
    // Try to detect if we should show currency code (match price-as-money.liquid logic)
    const showCurrencyCode = typeof window.theme !== 'undefined' && window.theme.settings && window.theme.settings.show_currency_code;
    let totalText = '';
    if (!cart || !cart.total_price || cart.item_count === 0) {
      // Empty cart: 0,00 + symbol (not code)
      totalText = `${cartTotalLabel} 0,00 ${currencySymbol}`;
    } else {
      // Always format dynamically in JS
      let formatted = '';
      const format = showCurrencyCode ? moneyWithCurrencyFormat : moneyFormat;
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        formatted = Shopify.formatMoney(cart.total_price, format);
      } else {
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = precision || 2;
          thousands = thousands || ',';
          decimal = decimal || '.';
          if (isNaN(number) || number == null) return '0,00';
          number = (number / 100.0).toFixed(precision);
          const parts = number.split('.');
          const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
          const centsAmount = parts[1] ? (decimal + parts[1]) : '';
          return dollarsAmount + centsAmount;
        }
        let value = '';
        const match = format.match(placeholderRegex);
        if (match) {
          switch (match[1]) {
            case 'amount':
              value = formatWithDelimiters(cart.total_price, 2);
              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(cart.total_price, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cart.total_price, 2, '.', ',');
              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cart.total_price, 0, '.', ',');
              break;
            case 'amount_with_space_separator':
              value = formatWithDelimiters(cart.total_price, 2, ' ', '.');
              break;
          }
        }
        formatted = format.replace(placeholderRegex, value);
      }
      totalText = `${cartTotalLabel} ${formatted}`;
    }
    totalEl.textContent = totalText;
  }

  // Helper: Fetch cart via AJAX
  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => updateHeaderCartTotal(cart));
  }

  // Listen for cart events
  document.addEventListener('on:cart:add', (event) => {
    if (event.detail && event.detail.cart) {
      updateHeaderCartTotal(event.detail.cart);
    } else {
      fetchCartAndUpdate();
    }
  });
  document.addEventListener('on:line-item:change', (event) => {
    if (event.detail && event.detail.cart) {
      updateHeaderCartTotal(event.detail.cart);
    } else {
      fetchCartAndUpdate();
    }
  });
  document.addEventListener('on:cart:error', fetchCartAndUpdate);

  // Listen for currency change (Currency.convertAll or DOM mutation)
  if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
    // Listen for a custom event or fallback to DOM mutation observer
    document.addEventListener('currency:changed', fetchCartAndUpdate);
    // Also observe the currency switcher if present
    const currencySwitcher = document.querySelector('[name=currency], .currency-selector');
    if (currencySwitcher && window.MutationObserver) {
      new MutationObserver(fetchCartAndUpdate).observe(currencySwitcher, { childList: true, subtree: true, attributes: true });
    }
  }

  // On page load, update header cart total
  fetchCartAndUpdate();

  // Optionally, re-run after Currency.convertAll (if present)
  if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
    const origConvertAll = Currency.convertAll;
    Currency.convertAll = function () {
      const result = origConvertAll.apply(this, arguments);
      setTimeout(fetchCartAndUpdate, 50);
      return result;
    };
  }
})();
